import { render, staticRenderFns } from "./fa.vue?vue&type=template&id=64cdc9c4"
import script from "./fa.vue?vue&type=script&lang=js"
export * from "./fa.vue?vue&type=script&lang=js"
import style0 from "./fa.vue?vue&type=style&index=0&id=64cdc9c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports